<template>
  <footer class="w-full bg-[#512851] text-white">
    <ul
      class="flex flex-wrap lg:flex-nowrap justify-center items-center gap-2 py-4"
    >
      <li><a href="https://oxoformdocs.fra1.digitaloceanspaces.com/6a4602857703e696070a311f/reglement.pdf" target="_blank">Règlement</a></li>
      <li>|</li>
      <li><a href="https://oxoformdocs.fra1.digitaloceanspaces.com/6a4602857703e696070a311f/mentions.pdf" target="_blank">Mentions légales</a></li>
      <li>|</li>
      <li><a href="https://oxoformdocs.fra1.digitaloceanspaces.com/6a4602857703e696070a311f/politique.pdf" target="_blank">Politique de confidentialité</a></li>
      <li>|</li>
      <li><a href="mailto:contact@promo.dev" target="_blank">Nous contacter</a></li>
    </ul>
  </footer>
</template>

<script>
export default {
  name: "footer-view",
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>
